import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { ENewsletterType } from '../../models/newsletter.model';

type Props = {
  value?: ENewsletterType | null;
  onChange?: (value: ENewsletterType | null) => void;
  label?: string;
  required?: boolean;
};

const NewsletterTypeSelect = (props: Props) => {
  const { value, onChange, label = 'Newsletter Type', required = false } = props;

  const typeOptions = [
    { value: ENewsletterType.Investor, label: 'Investor' },
    { value: ENewsletterType.Startup, label: 'Start-up' },
    { value: ENewsletterType.Researcher, label: 'Researcher' },
  ];

  return (
    <FormControl fullWidth required={required}>
      <InputLabel>{label}</InputLabel>
      <Select
        size="small"
        label={label}
        value={value || 'no-value'}
        onChange={(e) => {
          if (e.target.value === 'no-value') {
            onChange?.(null);
          } else {
            onChange?.(e.target.value as ENewsletterType);
          }
        }}
        displayEmpty
        renderValue={(selected) => {
          if (selected === 'no-value') {
            return 'Select newsletter type';
          }
          const option = typeOptions.find((opt) => opt.value === selected);
          return option?.label || 'Select newsletter type';
        }}
      >
        <MenuItem key={'empty'} value={'no-value'} sx={{ color: 'gray' }}>
          Select newsletter type
        </MenuItem>
        {typeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default NewsletterTypeSelect;